<div #findStaffWrapper class="find-staff-modal">
  @if (
    {
      isFetchedShiftAssignmentSuccessful:
        isFetchedShiftAssignmentSuccessful$ | async,
    };
    as data
  ) {
    @if (data.isFetchedShiftAssignmentSuccessful) {
      <wilson-find-staff-popup-filters>
        <wilson-grouped-activity-staff-status-filter></wilson-grouped-activity-staff-status-filter>
      </wilson-find-staff-popup-filters>
    }
    <wilson-modal-timeline [userTimelinesInfo]="userTimelinesInfo$ | async">
      <wilson-find-activity-staff-popup-quick-filter></wilson-find-activity-staff-popup-quick-filter>
    </wilson-modal-timeline>
    @defer (on idle) {
      <wilson-deferred-absence-timeline-view-card></wilson-deferred-absence-timeline-view-card>
      <wilson-deferred-shift-icons></wilson-deferred-shift-icons>
    }
    <wilson-timeline-modal-legend></wilson-timeline-modal-legend>
  }
</div>
